export const mockData = {
  hero: {
    slides: [
      {
        backgroundImage: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80",
        interiorImage: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=800&q=80",
        title: "NYINIMU PROPERTIES",
        subtitle: "DAILY PAYMENTS. YOUR HOME. BUY DAILY. OWN FOREVER."
      },
      {
        backgroundImage: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1200&q=80",
        interiorImage: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=800&q=80",
        title: "FROM TENANT TO LANDLORD",
        subtitle: "DAILY, NZE LANDLORD. YOUR HUSTLE, YOUR HOME."
      },
      {
        backgroundImage: "https://images.unsplash.com/photo-1600566753151-384129cf4e3e?auto=format&fit=crop&w=1200&q=80",
        interiorImage: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=800&q=80",
        title: "BUILDING YOUR LEGACY",
        subtitle: "DAY BY DAY. HOMEOWNERSHIP FOR EVERY UGANDAN."
      },
      {
        backgroundImage: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1200&q=80",
        interiorImage: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?auto=format&fit=crop&w=800&q=80",
        title: "THE PATH TO OWNERSHIP",
        subtitle: "STARTS WITH A STEP. AND A DAILY PAYMENT."
      }
    ]
  },
  stats: [
    { number: "Daily", label: "Payment Options" },
    { number: "100+", label: "New Landlords" },
    { number: "Forever", label: "Ownership" },
    { number: "24/7", label: "Your Home" }
  ],
  testimonials: [
    {
      quote: "Nyinimu Properties made my dream of owning a home come true. Their flexible payment plans fit my income perfectly.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80",
      name: "Sarah Nakato",
      role: "Salon Owner"
    },
    {
      quote: "The quality of construction and attention to detail is outstanding. I feel secure in my investment.",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=200&q=80",
      name: "David Mugisha",
      role: "Software Developer"
    },
    {
      quote: "As a DJ, my income varies, but Nyinimu understood my needs and helped me find the perfect home.",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80",
      name: "Maria Nansubuga",
      role: "Professional DJ"
    }
  ],
  features: [
    {
      icon: "Shield",
      title: "Secure Investment",
      description: "Your property investment is protected with our comprehensive security measures and legal safeguards."
    },
    {
      icon: "TrendingUp",
      title: "Value Appreciation",
      description: "Properties in prime locations appreciate in value, ensuring your investment grows over time."
    },
    {
      icon: "Clock",
      title: "Flexible Payments",
      description: "Payment plans designed to accommodate various income streams and financial situations."
    },
    {
      icon: "Home",
      title: "Quality Construction",
      description: "Built to the highest standards with premium materials and expert craftsmanship."
    },
    {
      icon: "Users",
      title: "Community Focus",
      description: "Creating vibrant communities where residents can thrive and connect with neighbors."
    },
    {
      icon: "Award",
      title: "Award Winning",
      description: "Recognized for excellence in real estate development and customer satisfaction."
    }
  ],
  clientLogos: [
    { name: "Company A", logo: "https://via.placeholder.com/120x60?text=Logo+A" },
    { name: "Company B", logo: "https://via.placeholder.com/120x60?text=Logo+B" },
    { name: "Company C", logo: "https://via.placeholder.com/120x60?text=Logo+C" },
    { name: "Company D", logo: "https://via.placeholder.com/120x60?text=Logo+D" },
    { name: "Company E", logo: "https://via.placeholder.com/120x60?text=Logo+E" },
    { name: "Company F", logo: "https://via.placeholder.com/120x60?text=Logo+F" }
  ],
  blog: [
    {
      id: 1,
      title: "The Future of Affordable Housing in Uganda",
      excerpt: "Exploring innovative solutions for making home ownership accessible to all Ugandans.",
      image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=800&q=80",
      date: "2024-01-15",
      author: "Nyinimu Team"
    },
    {
      id: 2,
      title: "Sustainable Building Practices",
      excerpt: "How we're incorporating eco-friendly materials and designs in our properties.",
      image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=800&q=80",
      date: "2024-01-10",
      author: "Environmental Team"
    },
    {
      id: 3,
      title: "Community Building Through Real Estate",
      excerpt: "Creating spaces that foster community and connection in urban environments.",
      image: "https://images.unsplash.com/photo-1516156008625-3a9d6067fab5?auto=format&fit=crop&w=800&q=80",
      date: "2024-01-05",
      author: "Community Manager"
    },
    {
      id: 4,
      title: "Investment Opportunities in Kampala",
      excerpt: "Why now is the perfect time to invest in Kampala's growing real estate market.",
      image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
      date: "2024-01-01",
      author: "Investment Advisor"
    }
  ],
  apartmentPlans: [
    {
      id: "studio",
      name: "Studio",
      price: "Daily Payments Available",
      area: "25-35 m²",
      bedrooms: 0,
      bathrooms: 1,
      features: ["Open Layout", "Compact Kitchen", "Modern Bathroom", "Storage Space"],
      constructionTime: "4 Months Max",
      paymentOptions: ["Daily Contributions", "Buy Daily, Own Forever"],
      motto: "Your hustle, your home"
    },
    {
      id: "1bedroom",
      name: "1 Bedroom",
      price: "Daily Payments Available", 
      area: "40-55 m²",
      bedrooms: 1,
      bathrooms: 1,
      features: ["Master Bedroom", "Living Area", "Kitchen", "Bathroom", "Wardrobe"],
      constructionTime: "4 Months Max",
      paymentOptions: ["Daily Contributions", "From Tenant to Landlord"],
      motto: "Building your legacy, day by day"
    },
    {
      id: "2bedroom",
      name: "2 Bedroom",
      price: "Daily Payments Available",
      area: "65-85 m²", 
      bedrooms: 2,
      bathrooms: 2,
      features: ["2 Bedrooms", "2 Bathrooms", "Living Room", "Dining Area", "Kitchen", "Storage"],
      constructionTime: "4 Months Max",
      paymentOptions: ["Daily Contributions", "Daily, Nze Landlord"],
      motto: "The path to ownership starts with a step"
    },
    {
      id: "3bedroom",
      name: "3 Bedroom",
      price: "Daily Payments Available",
      area: "95-120 m²",
      bedrooms: 3,
      bathrooms: 2,
      features: ["3 Bedrooms", "2 Bathrooms", "Living Room", "Dining Room", "Kitchen", "Master Suite"],
      constructionTime: "4 Months Max",
      paymentOptions: ["Daily Contributions", "Homeownership for Every Ugandan"],
      motto: "Nyinimu Properties. Daily payments. Your home."
    }
  ],
  propertyIcons: [
    { icon: "Home", label: "Apartments" },
    { icon: "Building", label: "Commercial" },
    { icon: "MapPin", label: "Locations" },
    { icon: "Shield", label: "Security" },
    { icon: "Car", label: "Parking" },
    { icon: "Wifi", label: "Amenities" }
  ],
  apartments: [
    {
      id: 1,
      name: "Nyinimu Starter Home",
      description: "Perfect entry-level unit for first-time homeowners.",
      image:
        "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80",
      area: "50m²",
      features: ["1 Bedroom", "1 Bathroom", "Open Kitchen", "Balcony"],
    },
    {
      id: 2,
      name: "Family Comfort Apartment",
      description: "Spacious living for growing families with modern amenities.",
      image:
        "https://images.unsplash.com/photo-1599423300746-b62533397364?auto=format&fit=crop&w=800&q=80",
      area: "85m²",
      features: ["2 Bedrooms", "2 Bathrooms", "Parking", "Play Area"],
    },
    {
      id: 3,
      name: "Executive Suite",
      description: "Luxury living with high-end finishes and city views.",
      image:
        "https://images.unsplash.com/photo-1599423300748-9a8d0fbb0a6a?auto=format&fit=crop&w=800&q=80",
      area: "120m²",
      features: ["3 Bedrooms", "2 Bathrooms", "Smart Home", "Private Balcony"],
    },
    {
      id: 4,
      name: "Urban Studio",
      description: "Compact and stylish studio in the heart of the city.",
      image:
        "https://images.unsplash.com/photo-1599423300749-dc7b5ec72e3f?auto=format&fit=crop&w=800&q=80",
      area: "35m²",
      features: ["Studio Layout", "1 Bathroom", "Compact Kitchen", "Workspace"],
    },
    {
      id: 5,
      name: "Luxury Penthouse",
      description: "Skyline views, spacious design, and unmatched elegance.",
      image:
        "https://images.unsplash.com/photo-1600585154200-99e3a3aef59c?auto=format&fit=crop&w=800&q=80",
      area: "200m²",
      features: ["4 Bedrooms", "3 Bathrooms", "Jacuzzi", "Private Terrace"],
    },
    {
      id: 6,
      name: "Garden Villa",
      description: "Experience serene living with private gardens and natural light.",
      image:
        "https://images.unsplash.com/photo-1600585154363-8322d8c8ef1e?auto=format&fit=crop&w=800&q=80",
      area: "150m²",
      features: ["3 Bedrooms", "2 Bathrooms", "Garden", "Parking"],
    },
    {
      id: 7,
      name: "Student Apartment",
      description: "Affordable and convenient housing for students near universities.",
      image:
        "https://images.unsplash.com/photo-1600585154276-7d4ef2d6b6b5?auto=format&fit=crop&w=800&q=80",
      area: "45m²",
      features: ["1 Bedroom", "Study Desk", "Shared Kitchen", "Wi-Fi"],
    },
    {
      id: 8,
      name: "Retirement Haven",
      description: "A peaceful retreat designed for comfort and accessibility.",
      image:
        "https://images.unsplash.com/photo-1600585154202-b4d516e6b1c2?auto=format&fit=crop&w=800&q=80",
      area: "90m²",
      features: ["2 Bedrooms", "2 Bathrooms", "Wheelchair Access", "Community Center"],
    },
    {
      id: 9,
      name: "Eco-Friendly Home",
      description: "Sustainable living with solar panels and green features.",
      image:
        "https://images.unsplash.com/photo-1600585154237-9a5af7d6a7f3?auto=format&fit=crop&w=800&q=80",
      area: "110m²",
      features: ["3 Bedrooms", "2 Bathrooms", "Solar Power", "Rainwater Harvesting"],
    },
  ],
};
